// Área "dashboard" — preenchida na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const dashboard = {
  pt: {
    'dashboard.available_balance': "Saldo disponível",
    'dashboard.account': "Conta {n}",
    'dashboard.make_pix': "Fazer PIX",
    'dashboard.view_statement': "Ver extrato",
    'dashboard.quick_actions': "Ações rápidas",
    'dashboard.statement': "Extrato",
    'dashboard.investments': "Investimentos",
    'dashboard.more': "Mais",
    'dashboard.date_unavailable': "Data indisponível",
    'dashboard.recipient': "destinatário",
    'dashboard.sender': "remetente",
    'dashboard.pix_sent_to': "PIX enviado para {n}",
    'dashboard.pix_received_from': "PIX recebido de {n}",
    'dashboard.latest_transactions': "Últimas transações",
    'dashboard.no_transactions': "Nenhuma transação encontrada.",
  },
  es: {
    'dashboard.available_balance': "Saldo disponible",
    'dashboard.account': "Cuenta {n}",
    'dashboard.make_pix': "Hacer PIX",
    'dashboard.view_statement': "Ver extracto",
    'dashboard.quick_actions': "Acciones rápidas",
    'dashboard.statement': "Extracto",
    'dashboard.investments': "Inversiones",
    'dashboard.more': "Más",
    'dashboard.date_unavailable': "Fecha no disponible",
    'dashboard.recipient': "destinatario",
    'dashboard.sender': "remitente",
    'dashboard.pix_sent_to': "PIX enviado a {n}",
    'dashboard.pix_received_from': "PIX recibido de {n}",
    'dashboard.latest_transactions': "Últimas transacciones",
    'dashboard.no_transactions': "No se encontraron transacciones.",
  },
  en: {
    'dashboard.available_balance': "Available balance",
    'dashboard.account': "Account {n}",
    'dashboard.make_pix': "Make PIX",
    'dashboard.view_statement': "View statement",
    'dashboard.quick_actions': "Quick actions",
    'dashboard.statement': "Statement",
    'dashboard.investments': "Investments",
    'dashboard.more': "More",
    'dashboard.date_unavailable': "Date unavailable",
    'dashboard.recipient': "recipient",
    'dashboard.sender': "sender",
    'dashboard.pix_sent_to': "PIX sent to {n}",
    'dashboard.pix_received_from': "PIX received from {n}",
    'dashboard.latest_transactions': "Latest transactions",
    'dashboard.no_transactions': "No transactions found.",
  },
  it: {
    'dashboard.available_balance': "Saldo disponibile",
    'dashboard.account': "Conto {n}",
    'dashboard.make_pix': "Fai PIX",
    'dashboard.view_statement': "Vedi estratto",
    'dashboard.quick_actions': "Azioni rapide",
    'dashboard.statement': "Estratto",
    'dashboard.investments': "Investimenti",
    'dashboard.more': "Altro",
    'dashboard.date_unavailable': "Data non disponibile",
    'dashboard.recipient': "destinatario",
    'dashboard.sender': "mittente",
    'dashboard.pix_sent_to': "PIX inviato a {n}",
    'dashboard.pix_received_from': "PIX ricevuto da {n}",
    'dashboard.latest_transactions': "Ultime transazioni",
    'dashboard.no_transactions': "Nessuna transazione trovata.",
  },
};

export default dashboard;
